/* eslint-disable import/prefer-default-export */
export const copyFiscalAddress = state => {
    return state.copyFiscalAddress;
};
